const e=async(e,t,n,r)=>{await e.delete(`/users/${t}/roles/${n}`,{params:r?{scope:r}:void 0})};export{e as revokeRole};
//# sourceMappingURL=revoke-role.mjs.map